// Device-local preference: show the week-close reveal on open when a closed week
// is still unseen (catch-up — the live reveal runs in the Sunday-evening
// session). Off by default. Storage key kept for continuity.
import AsyncStorage from '@react-native-async-storage/async-storage';

const key = (userId: string) => `olmps.mondayReveal.enabled.${userId}`;

export async function getRevealEnabled(userId: string): Promise<boolean> {
  try {
    return (await AsyncStorage.getItem(key(userId))) === '1';
  } catch {
    return false;
  }
}

export async function setRevealEnabled(userId: string, on: boolean): Promise<void> {
  try {
    await AsyncStorage.setItem(key(userId), on ? '1' : '0');
  } catch {
    /* best-effort */
  }
}
